
import { ReactComponent as Logo } from '../../assets/images/ocean-logo.svg'
import './index.css';


const header = () => (
  <header className='header'>
    <Logo/>
  </header>
)

export default header;